# frozen_string_literal: true

require_relative 'base'

module Engine
  module Ability
    class NoBuy < Base
    end
  end
end
